import { useQuery } from '@apollo/client';
import { get } from 'lodash/fp';
import { CURRENT_USER } from '../GraphQL/Queries';

const useCurrentUser = () => {
  const { data, error, loading } = useQuery(CURRENT_USER);

  return {
    currentUser: get('me', data),
    error,
    loading,
  };
};

export default useCurrentUser;
